<template>
    <footer class="site-footer-container">
        <div class="contact-company">
            <div class="contact-container">
                <div class="contact-label">
                    <p>{{ $t('footer.contactUs') }}<span>{{ $t('colonSuffix') }}</span></p>
                </div>
                <div class="contact-buttons">
                    <a :href="$t('footer.linkFacebook')">
                        <facebook-icon class="small-icon theme-fio-button"></facebook-icon>
                    </a>
                    <email-icon
                        class="small-icon theme-fio-button"
                        role="button"
                        tabindex="0"
                        @click="onShowEmailInfo"
                        @keypress.enter="onShowEmailInfo"
                        @keypress.space="onShowEmailInfo">
                    </email-icon>
                </div>
            </div>
            <div class="company-logo-container">
                <company-logo></company-logo>
            </div>
        </div>
        <div class="copyright">
            <i18n-t keypath="footer.copyrightNotice" tag="div" class="copyright-text">
                <template #start>{{ $t('startCopyright') }}</template>
                <template #end>{{ $t('endCopyright') }}</template>
                <template #company>{{ $t('companyName') }}</template>
            </i18n-t>
        </div>
        <contact-email-popin
            v-if="showEmail"
            :title="$t('footer.contactUsViaEmail') + $t('colonSuffix')"
            :user="$t('footer.linkEmailUser')"
            :domain="$t('footer.linkEmailDomain')"
            @close="onCloseEmailInfo"></contact-email-popin>
    </footer>
</template>

<script setup lang="ts">
import { ref } from "vue";
import ContactEmailPopin from "@/components/ContactEmailPopin.vue";

import FacebookIcon from "@/scalar/social-facebook.svg";
import EmailIcon from "@/scalar/social-email.svg";

import CompanyLogo from "@/scalar/company-logo.svg";

const showEmail = ref(false);

function onShowEmailInfo(): void {
    showEmail.value = true;
}

function onCloseEmailInfo(): void {
    showEmail.value = false;
}
</script>

<style>
.site-footer-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: var(--bg-colour);
    z-index: 2;
}

.contact-company {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
}

.contact-container {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.contact-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.contact-buttons > a {
    display: inherit;
}

.copyright {
    width: 100%;
    text-align: center;
    margin-top: 0.5em;
}

.company-logo-container {
    min-width: 100px; /* Needed to ensure Chrome aligns this correctly */
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    align-self: center;
}

.company-logo-container > svg {
    max-height: 2em;
}

.copyright-text { font-size: small; user-select: none; }

@media screen and (max-width: 400px) {
    .contact-label {
        display: none;
    }
}
</style>
